import React, { useEffect } from "react";
import "./Modal.css";

interface VideoModalProps {
    isOpen: boolean;
    title: string;
    videoUrl: string;
    onClose: () => void;
}

const VideoModal: React.FC<VideoModalProps> = ({ isOpen, title, videoUrl, onClose }) => {
    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const getEmbedUrl = (url: string) => {
        const videoId = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/);
        return videoId ? `https://www.youtube.com/embed/${videoId[1]}` : url;
    };

    return (
        <div className="modal-overlay">
            <div className="modal" style={{ width: '900px', maxWidth: '900px' }}>
                <div className="modal-close" onClick={onClose}>
                    <span className="modal-cancel-text">Cancel (ESC)</span>
                    <img src="/assets/x.svg" alt="Close" className="modal-close-icon" />
                </div>
                {title && <h2>{title}</h2>}
                <div className="modal-content">
                    <div className="video-container">
                        <iframe
                            src={getEmbedUrl(videoUrl)}
                            title={title}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VideoModal; 